module.exports = __webpack_public_path__ + "static/media/WndEITS.1af63507.jpg";